import { Component, Input, Output, EventEmitter } from '@angular/core';

export enum FilterType {
  TEXT,
  SELECT,
  DATE
}

export interface FilterProps {
  label: string;
  field: string;
  type: FilterType;
  options?: string[];
  multiple?: boolean;
}

@Component({
  selector: 'app-filter-panel',
  templateUrl: './filter-panel.component.html',
  styleUrls: ['./filter-panel.component.scss'],
})
export class FilterPanelComponent {
  @Input() filterProps: FilterProps[] = [];
  @Input() filters: { [key: string]: string[] | string } = {};
  @Output() filtersChanged = new EventEmitter<{ [key: string]: string[] | string }>();

  selectedFilter: string = '';

  inputValue: string = '';
  selectedOption: string = '';
  selectedDate: string | null = null; // For storing the selected date

  activeFilter: FilterProps | null = null;

  get filterKeys() {
    return Object.keys(this.filters);
  }

  onFilterChange(event: any) {
    this.activeFilter = this.filterProps.find((prop) => prop.field === this.selectedFilter);
    this.inputValue = '';
    this.selectedOption = '';
  }

  getFilterValues(key: string): string[] {
    const value = this.filters[key];
    return Array.isArray(value) ? value : [value];
  }

  addFilter() {
    if (!this.activeFilter) return;

    const updatedFilters = { ...this.filters };
    let valueToUpdate = '';

    if (this.activeFilter.type === FilterType.TEXT && this.inputValue) {
      valueToUpdate = this.inputValue;
    } else if (this.activeFilter.type === FilterType.SELECT && this.selectedOption) {
      valueToUpdate = this.selectedOption;
    } else if (this.activeFilter.type === FilterType.DATE && this.selectedDate) {
      valueToUpdate = this.selectedDate;
    }

    if (this.activeFilter.multiple) {
      const csvValues = valueToUpdate.trim().split(',');
      const currentValue = updatedFilters[this.activeFilter.field]
        ? [...(updatedFilters[this.activeFilter.field] as string[])]
        : [];
      if (typeof currentValue !== 'string') {
        csvValues.forEach((value) => currentValue.push(value));
      }
      updatedFilters[this.activeFilter.field] = currentValue;
    } else {
      updatedFilters[this.activeFilter.field] = valueToUpdate;
    }

    this.filters = updatedFilters;
    this.filtersChanged.emit(this.filters);

    this.inputValue = '';
    this.selectedOption = '';
    this.selectedDate = null;
  }

  removeFilter(key: string, value: string) {
    const updatedFilters = { ...this.filters };

    const currentValues = updatedFilters[key];
    if (Array.isArray(currentValues)) {
      const newValues = currentValues.filter((v) => v !== value);
      if (newValues.length === 0) {
        delete updatedFilters[key];
      } else {
        updatedFilters[key] = newValues;
      }
    } else {
      delete updatedFilters[key];
    }

    this.filters = updatedFilters;
    this.filtersChanged.emit(this.filters);
  }

  protected readonly FilterType = FilterType;
}
